import { API_URL } from '../../../app-config/constants';
import * as api from '../request';

const RESOURCE = `${API_URL}/objective-ratings`;

const withId = ratings => ({ id: 'objectiveRatings', ratings });

get.operation = 'READ';
export function get() {
    return api.get(RESOURCE).then(withId);
}

put.operation = 'COMMAND';
export function put(objectiveRatings = []) {
    return api.put(RESOURCE, { postData: objectiveRatings }).then(withId);
}
